import React from 'react';

interface CustomListsProps {
  items: string[][];
  listStyle?: 'disc' | 'decimal' | 'none';
  layout?: 'split' | 'stacked'; // default will be 'split'
  customBullet?: string;
  bullets?: string[][];
}

const CustomLists: React.FC<CustomListsProps> = ({
  items,
  listStyle = 'disc',
  layout = 'split',
  customBullet = '•',
  bullets,
}) => {
  const isSplit = layout === 'split';

  const getListClass = () => {
    switch (listStyle) {
      case 'decimal':
        return 'list-decimal';
      case 'none':
        return 'list-none';
      default:
        return 'list-disc';
    }
  };

  const getListTag = () => (listStyle === 'decimal' ? 'ol' : 'ul');

  const ListTag = getListTag();
  const listClass = getListClass();

  return (
    <div
      className={`grid ${
        isSplit ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'
      } gap-x-[clamp(1rem,2vw,2.5rem)] gap-y-[clamp(1rem,2vw,2rem)]`}
    >
      {items.map((group, groupIndex) => (
        <div
          key={groupIndex}
          className={`min-w-0 break-words ${isSplit ? 'col-span-1' : ''}`}
        >
      <ListTag
        className={`${listClass} pl-6 pr-[clamp(0.5rem,2vw,2rem)] word-spacing-wide tracking-normal leading-relaxed content-text-size whitespace-normal overflow-wrap-anywhere`}
        {...(listStyle === 'decimal' ? { start: groupIndex * group.length + 1 } : {})}
        style={{ listStylePosition: 'outside' }}
      >

  {group.map((item, itemIndex) => {
    const bullet = bullets?.[groupIndex]?.[itemIndex] ?? customBullet;

    return (
      <li
        key={itemIndex}
        className={`py-[clamp(0.4rem,1vw,0.9rem)] ${
          listStyle === 'none' ? 'flex items-start gap-3' : ''
        }`}
      >
        {listStyle === 'none' && (
          <span className="pt-[0.2em] shrink-0 text-lg leading-[1.4]">
            {bullet}
          </span>
        )}
        <span className="break-words">{item}</span>
      </li>
    );
  })}
</ListTag>

        </div>
      ))}
    </div>
  );
};

export default CustomLists;
